import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ModuleFE_Dialog } from '../../component-modules/ModuleFE_Dialog.js';
import { ComponentSync } from '../../core/ComponentSync.js';
import { _className } from '../../utils/tools.js';
import { TS_Video } from './Video.js';
import './VideoDialog.scss';
import { TS_Icons } from '@nu-art/ts-styles';
export class TS_VideoDialog extends ComponentSync {
    ref = React.createRef();
    //######################### Life Cycle #########################
    static show = (props) => {
        ModuleFE_Dialog.show({
            content: _jsx(TS_VideoDialog, { ...props }),
            closeOverlayOnClick: () => false,
            overlayClass: props.dialogOverlayClassName,
        });
    };
    componentDidMount() {
        this.updateSizing();
    }
    //######################### Logic #########################
    updateSizing = () => {
        const container = this.ref.current;
        if (!container)
            return;
        const rect = container.getBoundingClientRect();
        this.setState({ width: rect.width, height: rect.height });
    };
    getVideoProps = () => {
        return {
            source: this.props.source,
            configuration: this.props.configuration,
            unsupportedVideoMessage: this.props.unsupportedVideoMessage,
            width: this.state.width ?? 0,
            height: this.state.height ?? 0
        };
    };
    //######################### Render #########################
    render() {
        const className = _className('ts-video-dialog', this.props.dialogClassName);
        return _jsxs("div", { ref: this.ref, className: className, children: [_jsx(TS_Video, { ...this.getVideoProps() }), _jsx(TS_Icons.x.component, { onClick: () => ModuleFE_Dialog.close() })] });
    }
}
//# sourceMappingURL=VideoDialog.js.map